import { useNode } from '@craftjs/core';
import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';
import { HookFormMultipleDropdownField } from 'src/features/generalForms/uikit/hookFormFields/hookFormMultipleDropdownField';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { useMemo } from 'react';

export const FormMultipleDropdownInput: FormDropdownInputComponent = (props) => {
  const {
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  const options: DropdownOption[] = useMemo(
    () =>
      props.options?.map((option) => ({
        key: option.key,
        text: option.value,
      })) ?? [],
    [props.options],
  );

  if (!visible) {
    return <></>;
  }

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormMultipleDropdownField
        control={form.control}
        name={props.dataKey!}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        placeholder={props.placeholder}
        disabled={isDisabled}
        suggestion={props.suggestion}
        options={options}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        errorProps={{ errors }}
      />
    </div>
  );
};
